export default function Hamburger(){
    return <svg viewBox="0 0 20 20" width="20" height="20">
        <rect x="2" y="4" width="16" height="2" fill="black"/>
        <rect x="2" y="9" width="16" height="2" fill="black"/>
        <rect x="2" y="14" width="16" height="2" fill="black"/>
    </svg>
}